module.exports = __webpack_public_path__ + "img/man_raising_hand.4dd0c707.gif";